import { SelectOption } from '../../types';
import { keyBy } from 'lodash-es';

export const getGarnerSpecialtyById = (id: string): SelectOption | undefined => {
  const idFormatted = id.trim().toLowerCase();
  return garnerSpecialtiesMapById[idFormatted];
};

export const getGarnerSpecialtyByDescription = (description: string): SelectOption | undefined => {
  const descriptionFormatted = description.trim().toLowerCase();
  return garnerSpecialtiesMapByDescription[descriptionFormatted];
};

export const GARNER_SPECIALTIES = [
  { label: 'Addiction Medicine Physician', value: 'adult_addiction_medicine_physician' },
  { label: 'Addiction Therapist', value: 'adult_addiction_therapist' },
  { label: 'Adolescent General Psychologist', value: 'adolescent_general_psychologist' },
  { label: 'Adolescent Therapist', value: 'adolescent_therapist' },
  { label: 'Advanced Endoscopist', value: 'adult_advanced_endoscopist' },
  { label: 'Allergist', value: 'adult_allergist' },
  { label: 'Bariatric Surgeon', value: 'adult_bariatric_surgeon' },
  { label: 'Breast Cancer Surgeon', value: 'adult_breast_cancer_surgeon' },
  { label: 'Breast Medical Oncologist', value: 'adult_breast_medical_oncologist' },
  { label: 'Cardiac Surgeon', value: 'adult_cardiac_surgeon' },
  { label: 'Cardiologist', value: 'adult_general_cardiologist' },
  { label: 'Colorectal Surgeon', value: 'adult_colorectal_surgeon' },
  { label: 'Counselor', value: 'adult_therapist' },
  { label: 'Dermatologist', value: 'adult_general_dermatologist' },
  { label: 'Dietitian', value: 'adult_dietitian' },
  { label: 'Electrophysiologist', value: 'adult_electrophysiologist' },
  { label: 'Endocrinologist', value: 'adult_general_endocrinologist' },
  { label: 'Epileptologist', value: 'adult_epileptologist' },
  { label: 'Facial Plastic Surgeon', value: 'adult_facial_plastic_surgeon' },
  { label: 'Family Doctor', value: 'adult_primary_care_physician' },
  { label: 'Foot And Ankle Orthopedist', value: 'adult_foot_and_ankle_ortho' },
  { label: 'Gastroenterologist', value: 'adult_general_gastroenterologist' },
  { label: 'General Pediatrics', value: 'pediatric_general_pediatrician' },
  { label: 'General Surgeon', value: 'adult_general_surgeon' },
  { label: 'Genetic Counselor', value: 'adult_genetic_counselor' },
  { label: 'Geneticist', value: 'adult_geneticist' },
  { label: 'Geriatrician', value: 'adult_geriatrician' },
  { label: 'GI Medical Oncologist', value: 'adult_gi_medical_oncologist' },
  { label: 'GI Surgeon', value: 'adult_gi_surgeon' },
  { label: 'GU Medical Oncologist', value: 'adult_gu_medical_oncologist' },
  { label: 'Gynecologic Oncologist', value: 'adult_gynecologic_oncologist' },
  { label: 'Gynecologist (OBGYN)', value: 'adult_general_gynecologist' },
  { label: 'Hand Surgeon', value: 'adult_hand_surgeon' },
  { label: 'Head And Neck Surgeon', value: 'adult_head_neck_surgical_oncologist' },
  {
    label: 'Heart Failure And Transplant Cardiologist',
    value: 'adult_heart_failure_transplant_cardiologist',
  },
  { label: 'Hematologist Oncologist', value: 'adult_hematologist_oncologist' },
  { label: 'Hepatologist', value: 'adult_hepatologist' },
  { label: 'Hip Orthopedic Surgeon', value: 'adult_hip_orthopedic_surgeon' },
  { label: 'Imaging Center', value: 'mri_imaging_center' },
  { label: 'Infectious Disease Specialist', value: 'adult_infectious_disease_specialist' },
  { label: 'Interventional Cardiologist', value: 'adult_interventional_cardiologist' },
  { label: 'Interventional Nephrologist', value: 'adult_interventional_nephrologist' },
  { label: 'Interventional Radiologist', value: 'adult_interventional_radiologist' },
  { label: 'Knee (Non-Sport) Orthopedic Surgeon', value: 'adult_nonsport_knee_orthopedic_surgeon' },
  { label: 'Laryngologist', value: 'adult_laryngologist' },
  { label: 'Lung Medical Oncologist', value: 'adult_lung_medical_oncologist' },
  { label: 'Medical Laboratory', value: 'lab' },
  { label: 'Mohs Surgeon', value: 'adult_mohs_surgeon' },
  { label: 'Muscular Neurologist (MS Specialist)', value: 'adult_muscular_neurologist' },
  { label: 'Nephrologist', value: 'adult_general_nephrologist' },
  { label: 'Neuro-Oncologist', value: 'adult_neuro_oncologist' },
  { label: 'Neurologist', value: 'adult_general_neurologist' },
  { label: 'Neurosurgeon', value: 'adult_nonspine_neurosurgeon' },
  { label: 'Nonsurgical Orthopedist', value: 'adult_nonsurgical_orthopedic_physician' },
  { label: 'Obstetrician (OBGYN)', value: 'adult_obstetrician' },
  { label: 'Occupational Therapist', value: 'adult_occupational_therapist' },
  { label: 'Oncologic Nonspine Neurosurgeon', value: 'adult_oncologic_nonspine_neurosurgeon' },
  { label: 'Ophthalmologist (Eye Doctor)', value: 'adult_general_ophthalmologist' },
  { label: 'Otolaryngologist (ENT)', value: 'adult_general_ent' },
  { label: 'Pain Doctor', value: 'adult_pain_medicine' },
  { label: 'Pain Management Specialist', value: 'adult_pain_medicine' },
  { label: 'Pain Medicine Specialist', value: 'adult_pain_medicine' },
  { label: 'Pediatric Addiction Therapist', value: 'pediatric_addiction_therapist' },
  { label: 'Pediatric Allergist', value: 'pediatric_allergist' },
  { label: 'Pediatric Cardiologist', value: 'pediatric_pediatric_cardiologist' },
  { label: 'Pediatric Counselor', value: 'pediatric_therapist' },
  { label: 'Pediatric Cranial Specialist', value: 'pediatric_pediatric_cranial_specialist' },
  { label: 'Pediatric Dermatologist', value: 'pediatric_pediatric_dermatologist' },
  { label: 'Pediatric Dietitian', value: 'pediatric_dietitian' },
  { label: 'Pediatric Endocrinologist', value: 'pediatric_pediatric_endocrinologist' },
  { label: 'Pediatric ENT', value: 'pediatric_general_ent' },
  { label: 'Pediatric Epileptologist', value: 'pediatric_epileptologist' },
  { label: 'Pediatric Foot And Ankle Orthopedist', value: 'pediatric_foot_and_ankle_ortho' },
  { label: 'Pediatric Gastroenterologist', value: 'pediatric_pediatric_gastroenterologist' },
  { label: 'Pediatric General Surgeon', value: 'pediatric_pediatric_general_surgeon' },
  { label: 'Pediatric Genetic Counselor', value: 'pediatric_genetic_counselor' },
  { label: 'Pediatric Geneticist', value: 'pediatric_geneticist' },
  {
    label: 'Pediatric Hematologist Oncologist',
    value: 'pediatric_pediatric_hematologist_oncologist',
  },
  {
    label: 'Pediatric Infectious Disease Specialist',
    value: 'pediatric_pediatric_infectious_disease_specialist',
  },
  {
    label: 'Pediatric Interventional Cardiologist',
    value: 'pediatric_pediatric_interventional_cardiologist',
  },
  { label: 'Pediatric Nephrologist', value: 'pediatric_pediatric_nephrologist' },
  { label: 'Pediatric Neurologist', value: 'pediatric_pediatric_neurologist' },
  { label: 'Pediatric Neurosurgeon', value: 'pediatric_nonspine_neurosurgeon' },
  { label: 'Pediatric Occupational Therapist', value: 'pediatric_occupational_therapist' },
  {
    label: 'Pediatric Oncologic Nonspine Neurosurgeon',
    value: 'pediatric_oncologic_nonspine_neurosurgeon',
  },
  { label: 'Pediatric Ophthalmologist', value: 'pediatric_pediatric_ophthalmologist' },
  { label: 'Pediatric Ortho', value: 'pediatric_pediatric_ortho' },
  { label: 'Pediatric Physical Therapist', value: 'pediatric_physical_therapist' },
  { label: 'Pediatric Psychiatrist', value: 'pediatric_psychiatrist' },
  { label: 'Pediatric Psychologist', value: 'pediatric_general_psychologist' },
  { label: 'Pediatric Pulmonologist', value: 'pediatric_pediatric_pulmonologist' },
  { label: 'Pediatric Rheumatologist', value: 'pediatric_pediatric_rheumatologist' },
  {
    label: 'Pediatric Speech-Language Pathologist',
    value: 'pediatric_speech_language_pathologist',
  },
  { label: 'Pediatric Spine Neurosurgeon', value: 'pediatric_spine_neurosurgeon' },
  { label: 'Pediatric Spine Orthopedist', value: 'pediatric_spine_orthopedist' },
  { label: 'Pediatric Spine Surgeon', value: 'pediatric_spine_surgeon' },
  { label: 'Pediatric Therapist', value: 'pediatric_therapist' },
  { label: 'Pediatric Urologist', value: 'pediatric_pediatric_urologist' },
  { label: 'Pediatrician', value: 'pediatric_general_pediatrician' },
  { label: 'Perinatologist / Maternal-Fetal Medicine Specialist', value: 'adult_perinatologist' },
  { label: 'Physiatrist', value: 'adult_physiatrist' },
  { label: 'Physical Therapist', value: 'adult_physical_therapist' },
  { label: 'Podiatrist', value: 'adult_podiatrist' },
  { label: 'Primary Care Physician (PCP)', value: 'adult_primary_care_physician' },
  { label: 'Psychiatrist', value: 'adult_psychiatrist' },
  { label: 'Psychologist', value: 'adult_general_psychologist' },
  { label: 'Pulmonologist (Lung Doctor)', value: 'adult_general_pulmonologist' },
  { label: 'Radiation Oncologist', value: 'adult_radiation_oncologist' },
  { label: 'Reproductive Endocrinologist', value: 'adult_reproductive_endocrinologist' },
  { label: 'Rheumatologist', value: 'adult_general_rheumatologist' },
  { label: 'Rhinologist', value: 'adult_rhinologist' },
  { label: 'Shoulder Surgeon', value: 'adult_shoulder_surgeon' },
  { label: 'Sleep Medicine Specialist', value: 'adult_sleep_medicine_specialist' },
  { label: 'Sleep Neurologist', value: 'adult_sleep_neurologist' },
  { label: 'Speech-Language Pathologist', value: 'adult_speech_language_pathologist' },
  { label: 'Spine Neurosurgeon', value: 'adult_spine_neurosurgeon' },
  { label: 'Spine Orthopedist', value: 'adult_spine_orthopedist' },
  { label: 'Spine Surgeon', value: 'adult_spine_surgeon' },
  { label: 'Sports Knee Surgeon', value: 'adult_sports_knee_surgeon' },
  { label: 'Sports Medicine Physician', value: 'adult_sports_medicine_physician' },
  { label: 'Sports Orthopedic Surgeon', value: 'adult_sports_orthopedic_surgeon' },
  { label: 'Surgical Gynecologist', value: 'adult_surgical_gynecologist' },
  { label: 'Therapist', value: 'adult_therapist' },
  { label: 'Thoracic Oncologist', value: 'adult_thoracic_oncologist' },
  { label: 'Transplant Hepatologist', value: 'adult_transplant_hepatologist' },
  { label: 'Transplant Nephrologist', value: 'adult_transplant_nephrologist' },
  { label: 'Transplant Surgeon', value: 'adult_transplant_surgeon' },
  { label: 'Urgent Care Clinic', value: 'urgent_care_clinic' },
  { label: 'Urogynecologist', value: 'adult_urogynecologist' },
  { label: 'Urologic Oncologist', value: 'adult_urologic_oncologist' },
  { label: 'Urologist', value: 'adult_general_urologist' },
  { label: 'Vascular Neurologist (Stroke Specialist)', value: 'adult_vascular_neurologist' },
  { label: 'Vascular Surgeon', value: 'adult_vascular_surgeon' },
  { label: 'Vitreoretinal Specialist', value: 'adult_vitreoretinal_specialist' },
];

const garnerSpecialtiesMapById = keyBy(GARNER_SPECIALTIES, (specialty) =>
  specialty.value.trim().toLowerCase(),
);

const garnerSpecialtiesMapByDescription = keyBy(GARNER_SPECIALTIES, (specialty) =>
  specialty.label.trim().toLowerCase(),
);
